import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Русские переводы
import ruCommon from './locales/ru/common.json';
import ruAuth from './locales/ru/auth.json';
import ruNav from './locales/ru/nav.json';
import ruDashboard from './locales/ru/dashboard.json';
import ruErrors from './locales/ru/errors.json';

// Казахские переводы
import kkCommon from './locales/kk/common.json';
import kkAuth from './locales/kk/auth.json';
import kkNav from './locales/kk/nav.json';
import kkDashboard from './locales/kk/dashboard.json';
import kkErrors from './locales/kk/errors.json';

const resources = {
    ru: {
        common: ruCommon,
        auth: ruAuth,
        nav: ruNav,
        dashboard: ruDashboard,
        errors: ruErrors,
    },
    kk: {
        common: kkCommon,
        auth: kkAuth,
        nav: kkNav,
        dashboard: kkDashboard,
        errors: kkErrors,
    },
};

i18n
    .use(LanguageDetector) // Автоматическое определение языка
    .use(initReactI18next) // Интеграция с React
    .init({
        resources,
        fallbackLng: 'ru', // Язык по умолчанию
        lng: localStorage.getItem('language') || 'ru', // Сохраненный язык или русский
        defaultNS: 'common',
        ns: ['common', 'auth', 'nav', 'dashboard', 'errors'],
        interpolation: {
            escapeValue: false, // React уже экранирует значения
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'language',
        },
    });

export default i18n;
